import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import TextField from '@material-ui/icons/TextFields';
import Edit from '@material-ui/icons/Edit';

import randomstring from 'uuid/v4';

class PresentationDialog extends React.Component {
    state = {
        fields: this.props.fields,
    };

    handleClose = (value, type) => (event) => {
        if (value && !value.campos && !value.hijos) {
            this.props.onClose(value, type);
        } else if (!value) {
            this.props.onClose(undefined);
        }
    };

    setHide = (arr, codigo) => {
        return arr.map((item) => {
            if (item.campos) {
                item.campos = this.setHide(item.campos, codigo);
            }
            if (item.hijos) {
                item.hijos = this.setHide(item.hijos, codigo);
            }
            if (item.codigo === codigo) item.show = !item.show;
            return item;
        });
    };

    handleHide = (item) => (event) => {
        if (item.campos || item.hijos) {
            this.setState({ fields: this.setHide(this.state.fields, item.codigo) });
        }
    };

    render() {
        const { fields } = this.state;

        const Field = (item) => {
            const i = item.item;
            return (
                <React.Fragment>
                    <div key={randomstring()} className="flex_full_row boxShadow  hand">
                        {(i.campos || i.hijos) && (
                            <div
                                className={
                                    'display_flex heigth100 width64px elements_center text_align_center align_center borderRadiusLeft hand bg_black_10 '
                                }
                                onClick={this.handleHide(i)}
                            >
                                {!i.show && (
                                    <ExpandMore
                                        className={
                                            'icon margin_top_9 margin_right_12 gradIcon c_white'
                                        }
                                    />
                                )}
                                {i.show && (
                                    <ExpandLess
                                        className={
                                            'icon margin_top_9 margin_right_12 gradIcon c_white'
                                        }
                                    />
                                )}
                            </div>
                        )}
                        <div
                            className={
                                'flex_full_row barlow_regular_textwrap c_slate text_align_left padding_borders_text text_wrap hand gradIcon upper bg_white'
                            }
                            dangerouslySetInnerHTML={{ __html: i.nombre }}
                        />
                        {!i.campos && !i.hijos && (
                            <div className={'flex_auto_row'}>
                                <TextField
                                    className={
                                        'display_flex height100 center icon gradIcon c_lipstick hand'
                                    }
                                    onClick={this.handleClose(i, 'nombre')}
                                />
                                <Edit
                                    className={
                                        'display_flex height100 center icon gradIcon c_bluish hand margin_right_6'
                                    }
                                    onClick={this.handleClose(i, 'variable')}
                                />
                            </div>
                        )}
                    </div>
                    <div key={randomstring()} className="flex_full_column margin_left_12">
                        {i.show &&
                            i.campos &&
                            i.campos.length > 0 &&
                            i.campos.map((f) => {
                                return <Field key={randomstring()} item={f} />;
                            })}
                        {i.show &&
                            i.hijos &&
                            i.hijos.length > 0 &&
                            i.hijos.map((f) => {
                                return <Field key={randomstring()} item={f} />;
                            })}
                    </div>
                </React.Fragment>
            );
        };

        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={''}>
                    <div className="flex_full_column">
                        {fields &&
                            fields.length > 0 &&
                            fields.map((i) => {
                                return <Field key={randomstring()} item={i} />;
                            })}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default PresentationDialog;



// WEBPACK FOOTER //
// ./src/components/complex/manage/template/DialogFields.js